var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item.children)?_c('i',{staticClass:"menu-arrow",class:{'open-arrow' : _vm.isOpen}},[_c('font-awesome-icon',{attrs:{"icon":['far', 'angle-right']}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }